{
    "webshop_offer_voucher_correctCode": "正しいコードが入力されました",
    "webShop_howToFindId_desc": "個人IDは、プレーヤープロフィールからコピーできます。",
    "webShop_howToFindId_link": "個人IDはどこにありますか？",
    "webshop_offer_voucher_codeIsIncorrect": "コードが間違っています",
    "webshop_offer_voucher_enterYourCode": "個人IDを入力する",
    "webShop_unexpectedError_desc": "予期しないエラーが発生しました。後でもう一度お試しください。",
    "webShop_accountBanned_desc": "アカウントが停止されました！",
    "webshop_confirm": "OK",
    "webshop_termsConditions_1": "利用規約",
    "webshop_purchase_privacyPolicy": "プライバシーポリシー",
    "webshop_legal_1": "法的事項",
    "webshop_support_1": "サポート",
    "mbs_access_welcome_desc": "{0}さん、ようこそ。",
    "btn_login": "ログイン",
    "mbs_access_error_sessionExpired_desc": "セッションが失効しました。アカウントIDを手動で入力してください。"
}
